import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs';
import { ApplicationService } from './application.service';

@Injectable({
  providedIn: 'root'
})
export class NoProjectsGuard implements CanActivate {
  constructor(
    private applicationService: ApplicationService,
    private router: Router
  ) {}

  public canActivate(): Observable<boolean> {
    return this.applicationService.$hasProjects.pipe(
      tap(_ => {
        if (!_) {
          this.router.navigate(['/no-projects']);
        }
      }),
      take(1)
    );
  }
}
